module.exports = __webpack_public_path__ + "img/DeepGray_ReceivedToTransport@2x.71d000e5.png";